/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'FlashCardReport',

  data: () => {
    return {
      errInfo: '',
      errDesc: '',
    };
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_modalCardType: 'modalCardType',
      ms_flashCardDetail: 'flashCardDetail',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_MODAL_CARD_TYPE: 'SET_MODAL_CARD_TYPE',
      mm_SET_IS_FLASH_CARD_REPORTED: 'SET_IS_FLASH_CARD_REPORTED',
    }),

    ...mapActions('FlashCard/FlashCardDetail', {
      ma_flashCardReport: 'flashCardReport',
    }),

    toggleReport() {
      this.mm_SET_MODAL_CARD_TYPE('');
    },

    async flashCardReport() {
      await this.ma_flashCardReport({
        cardDetailId: this.ms_flashCardDetail.cardDetailId,
        comment: this.errInfo + (this.errDesc ? '  ' + this.errDesc : ''),
      });
      await Swal.fire({
        // position: 'top-end',
        backdrop: false,
        icon: 'success',
        width: '400px',
        title: `已经反馈问题`,
        showConfirmButton: false,
        timer: 800,
      });
      this.mm_SET_IS_FLASH_CARD_REPORTED(true);
      this.mm_SET_MODAL_CARD_TYPE('');
    },

    clearFlashCardReport() {
      this.mm_SET_IS_FLASH_CARD_REPORTED(false);
      this.errInfo = '';
      this.errDesc = '';
    },
  },
};
